type AccessoryIdentifier = {
  slug?: string | null;
  sku?: string | null;
  name?: string | null;
};

const WALL_DECOR_PRODUCTS = new Set([
  'canvas-print',
  'foto-op-canvas',
  'photo-poster',
  'foto-op-poster',
]);

const WALL_DECOR_BLOCKED_ACCESSORIES = new Set([
  'ophangplaat',
  'ophangplaten',
  'panel-hanging-plates',
  'blind-ophangsysteem',
  'blind-ophangsystemen',
  'hanging-aluminum-frame',
]);

function normalize(value: unknown) {
  return String(value || '').trim().toLowerCase();
}

export function isCompatiblePrintComAccessory(
  productLookupKey: string,
  accessory: AccessoryIdentifier,
) {
  if (!WALL_DECOR_PRODUCTS.has(normalize(productLookupKey))) return true;
  return ![accessory.slug, accessory.sku, accessory.name]
    .map(normalize)
    .some((identifier) => WALL_DECOR_BLOCKED_ACCESSORIES.has(identifier));
}

export function filterCompatiblePrintComAccessories<T extends AccessoryIdentifier>(
  productLookupKey: string,
  accessories: T[],
) {
  return accessories.filter((accessory) =>
    isCompatiblePrintComAccessory(productLookupKey, accessory)
  );
}
